import React, { forwardRef } from 'react';
import ContentSection from '@/pages/Products/VpsOciDetailPage/components/ContentSection';
import useLocale from '@/hooks/useLocale';
import * as Styles from './VPSInfo.styles';
import { useSelector } from 'react-redux';
import {
  IconGlobe, IconLocation2, IconChip, IconMemory, IconDisk,
} from 'gatorcomponents';

const VPSInfo = forwardRef((props, ref) => {
  const vpsOci = useSelector(state => state.vpsOci);
  const { vps } = (vpsOci && vpsOci.data) || {};

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: locale } = productDetailsLocale;

  if (!vps || Object.keys(vps).length === 0) return null;

  const vpsData = [
    {
      icon: <IconGlobe
        backgroundColor="transparent"
        color="lowDark"
        secondaryColor="transparent"
        testId="IconGlobe"
      />,
      label: locale.infoVps.serverIp,
      value: vps.serverIp,
    },
    {
      icon: <IconLocation2 testId="IconLocation2" />,
      label: locale.infoVps.datacenter,
      value: vps.datacenter,
    },
    {
      icon: <IconChip testId="IconChip" />,
      label: locale.infoVps.processor,
      value: vps.processor,
    },
    {
      icon: <IconMemory testId="IconMemory" />,
      label: locale.infoVps.memory,
      value: vps.memory,
    },
    {
      icon: <IconDisk testId="IconDisk" />,
      label: locale.infoVps.disk,
      value: vps.disk,
    },
  ].filter(item => item.value);

  if (vpsData.length === 0) return null;

  return (
    <ContentSection
      ref={ref}
      direction="column"
      align="flex-start"
      justify="flex-start"
      flex={2}
      title={locale.infoVps.title.text}
      tooltip={locale.infoVps.title.tooltip}
      testId="vps-info-section"
    >
      <Styles.ListItems>
        {vpsData.map(item => (
          <Styles.Item key={item.label}>
            <Styles.ItemLabel>
              {item.icon && item.icon}
              {item.label && item.label}
            </Styles.ItemLabel>
            <Styles.ItemValue>{item.value && item.value}</Styles.ItemValue>
          </Styles.Item>
        ))}
      </Styles.ListItems>
    </ContentSection>
  );
});

VPSInfo.displayName = 'VPSInfo';

export default VPSInfo;
